// components/VideoPlayer/SubtitleSettings/SubtitleItem.jsx
import React, { useState } from "react";
import { DISPLAY_MODES } from "../../../context/SubtitleSettingsContext";
import "./SubtitleItem.css";
import {
  getMainLanguageOptions,
  getAllLanguageOptions,
  getLanguageName,
} from "../../../utils/languages";

const SubtitleItem = ({
  subNumber,
  title,
  currentLanguage,
  currentMode,
  disabled,
  onLanguageChange,
  onModeChange,
}) => {
  const [showLangMenu, setShowLangMenu] = useState(false);
  const [showModeMenu, setShowModeMenu] = useState(false);
  const [showAllLangs, setShowAllLangs] = useState(false);

  const mainLanguages = getMainLanguageOptions();

  const modes = [
    { code: DISPLAY_MODES.SHOW, name: "نمایش", icon: "👁️" },
    { code: DISPLAY_MODES.HIDDEN, name: "پنهان", icon: "🙈" },
    { code: DISPLAY_MODES.UNDERCOVER, name: "زیر کاور", icon: "🕵️" },
  ];

  const handleLanguageSelect = (langCode) => {
    if (onLanguageChange) {
      onLanguageChange(langCode);
    }
    setShowLangMenu(false);
    setShowAllLangs(false);
  };

  const handleModeSelect = (modeCode) => {
    if (onModeChange) {
      onModeChange(modeCode);
    }
    setShowModeMenu(false);
  };

  return (
    <div className={`si-item ${disabled ? "si-disabled" : ""}`}>
      <div className="si-header">
        <span className="si-number">{subNumber}</span>
        <span className="si-title">{title}</span>
      </div>

      {/* انتخاب زبان */}
      <div className="si-setting">
        <span className="si-label">
          <span className="si-setting-icon">🌐</span>
          زبان
        </span>
        <div className="si-value-wrapper">
          <button
            className="si-value-btn"
            onClick={() => !disabled && setShowLangMenu(!showLangMenu)}
            disabled={disabled}
          >
            <span>{currentLanguage}</span>
            <span className="si-dropdown-arrow">▼</span>
          </button>
          {showLangMenu && (
            <div className="si-dropdown">
              {mainLanguages.map((lang) => (
                <button
                  key={lang.code}
                  className={`si-dropdown-item ${getLanguageName(currentLanguage) === lang.name ? "si-active" : ""}`}
                  onClick={() => handleLanguageSelect(lang.code)}
                >
                  <span>{lang.name}</span>
                  {getLanguageName(currentLanguage) === lang.name && (
                    <span className="si-check-mark">✓</span>
                  )}
                </button>
              ))}
              {showAllLangs && (
                <>
                  <div className="si-dropdown-divider"></div>
                  {(() => {
                    const { others } = getAllLanguageOptions();
                    return others.map((lang) => (
                      <button
                        key={lang.code}
                        className={`si-dropdown-item ${getLanguageName(currentLanguage) === lang.name ? "si-active" : ""}`}
                        onClick={() => handleLanguageSelect(lang.code)}
                      >
                        <span>{lang.name}</span>
                        {getLanguageName(currentLanguage) === lang.name && (
                          <span className="si-check-mark">✓</span>
                        )}
                      </button>
                    ));
                  })()}
                </>
              )}
              <button
                className="si-dropdown-item si-show-all-btn"
                onClick={() => setShowAllLangs(!showAllLangs)}
              >
                <span>{showAllLangs ? "🔺 نمایش کمتر" : "🔽 نمایش همه زبان‌ها"}</span>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* انتخاب حالت نمایش */}
      <div className="si-setting">
        <span className="si-label">
          <span className="si-setting-icon">🎭</span>
          حالت نمایش
        </span>
        <div className="si-value-wrapper">
          <button
            className="si-value-btn"
            onClick={() => !disabled && setShowModeMenu(!showModeMenu)}
            disabled={disabled}
          >
            <span>{currentMode}</span>
            <span className="si-dropdown-arrow">▼</span>
          </button>
          {showModeMenu && (
            <div className="si-dropdown">
              {modes.map((mode) => (
                <button
                  key={mode.code}
                  className={`si-dropdown-item ${currentMode === mode.name ? "si-active" : ""}`}
                  onClick={() => handleModeSelect(mode.code, mode.name)}
                >
                  <span className="si-mode-icon">{mode.icon}</span>
                  <span>{mode.name}</span>
                  {currentMode === mode.name && (
                    <span className="si-check-mark">✓</span>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubtitleItem;
